import { FormattedMessage } from 'dibs-react-intl';
import { FC } from 'react';
import { useFragment, graphql } from 'react-relay';
import classnames from 'classnames';
import styles from './styles/RingSizeDisplay.scss';

import { RingSizeDisplay_item$key } from './__generated__/RingSizeDisplay_item.graphql';
import { RingSizeDisplay_transaction$key } from './__generated__/RingSizeDisplay_transaction.graphql';

type Props = {
    item: RingSizeDisplay_item$key;
    transaction: RingSizeDisplay_transaction$key;
    textSize?: 'x-small' | 'small' | null;
    paddingTop?: 'x-small' | 'none';
};

export const RingSizeDisplay: FC<Props> = ({
    item: itemRef,
    transaction: transactionRef,
    textSize = 'small',
    paddingTop = 'x-small',
}) => {
    const item = useFragment(
        graphql`
            fragment RingSizeDisplay_item on Item {
                isRingItem
            }
        `,
        itemRef
    );
    const transaction = useFragment(
        graphql`
            fragment RingSizeDisplay_transaction on Transaction {
                buyerCurrency
                sku {
                    ringSizeDisplay {
                        mm
                        us
                    }
                }
            }
        `,
        transactionRef
    );

    const { isRingItem } = item || {};
    const { buyerCurrency, sku } = transaction || {};
    const ringSizeAttr = sku?.ringSizeDisplay;
    const showUSRingSize = buyerCurrency && buyerCurrency === 'USD';
    const ringValueText = showUSRingSize ? ringSizeAttr?.us : ringSizeAttr?.mm;

    return isRingItem && !!ringValueText ? (
        <div
            className={classnames({
                [styles.ringSizePaddingTopXSmall]: paddingTop === 'x-small',
                [styles.ringSizePaddingTopNone]: paddingTop === 'none',
            })}
        >
            <span
                className={classnames({
                    [styles.ringSizeLabelXSmall]: textSize === 'x-small',
                    [styles.ringSizeLabel]: textSize === 'small',
                })}
                data-tn="confirmation-item-attribute-name"
            >
                <FormattedMessage id="shared.ringSizeLabel" defaultMessage="Ring Size: " />
            </span>
            <span
                className={classnames({
                    [styles.ringSizeValueXSmall]: textSize === 'x-small',
                    [styles.ringSizeValue]: textSize === 'small',
                })}
                data-tn="confirmation-item-attribute-option"
            >
                {ringValueText}
            </span>
        </div>
    ) : null;
};
